import React from 'react';
import useDashboardApexChart from '../../hook/useDashboardApexChart';

const UsersGraph = ({ graphData, newUsers }) => {

      const { createUserChart } = useDashboardApexChart();

      // console.log("user graph ====>", graphData);

      const {
            totalUsers = 0,
            trendUsers = [],
            xAxisLabels = []
      } = graphData || {};

      return (
            <div className="col-xxl-12">
                  <div className="card radius-8 border-0 p-20">
                        <div className="row gy-4">

                              {/* TOTAL USERS */}
                              <div className="col-xxl-3 d-flex flex-column">

                                    <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-1 mb-12 flex-fill">
                                          <div className="card-body p-0">
                                                <div className="d-flex align-items-center gap-2 mb-12">
                                                      <span className="mb-0 w-48-px h-48-px bg-base text-primary text-2xl d-flex justify-content-center align-items-center rounded-circle h6">
                                                            <i className="ri-user-3-fill"></i>
                                                      </span>
                                                      <span className="fw-medium text-secondary-light text-lg">
                                                            Total Users
                                                      </span>
                                                </div>

                                                <div className="d-flex align-items-center justify-content-between">
                                                      <h5 className="fw-semibold mb-0">{totalUsers}</h5>
                                                </div>
                                          </div>
                                    </div>

                                    <div className="card p-3 radius-8 shadow-none bg-gradient-dark-start-2 mb-12 flex-fill">
                                          <div className="card-body p-0">
                                                <div className="d-flex align-items-center gap-2 mb-12">
                                                      <span className="mb-0 w-48-px h-48-px bg-base text-purple text-2xl d-flex justify-content-center align-items-center rounded-circle h6">
                                                            <i className="ri-checkbox-circle-fill"></i>
                                                      </span>
                                                      <span className="fw-medium text-secondary-light text-lg">
                                                            New Users
                                                      </span>
                                                </div>

                                                <div className="d-flex align-items-center justify-content-between">
                                                      <h5 className="fw-semibold mb-0">{newUsers}</h5>
                                                </div>
                                          </div>
                                    </div>

                              </div>

                              {/* CHART */}
                              <div className="col-xxl-9">
                                    <div className="card-body p-0">
                                          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                                                <h6 className="mb-2 mt-1 fw-bold text-lg">Users Trend</h6>
                                          </div>

                                          <ul className="d-flex justify-content-center mt-3 gap-3 stats-legend">
                                                <li className="d-flex align-items-center gap-2">
                                                      <span className="w-12-px h-12-px rounded-circle bg-primary-600" />
                                                      Today Users<span className="legend-value">: <b>{newUsers}</b></span>
                                                </li>
                                                {/* <li className="d-flex align-items-center gap-2">
                                                      <span className="w-12-px h-12-px rounded-circle bg-primary-600" />
                                                      Total Users
                                                      <span className="legend-value">: <b>{totalUsers}</b></span>
                                                </li> */}
                                          </ul>

                                          <div className="mt-40">
                                                <div id="usersChart" className="apexcharts-tooltip-style-1">
                                                      {
                                                            createUserChart('#487fff', trendUsers, xAxisLabels)
                                                      }
                                                </div>
                                          </div>
                                    </div>
                              </div>

                        </div>
                  </div>
            </div>
      );
};

export default UsersGraph;